import React from 'react';
import ActivateObject from '../../../common/poppers/ActivateObject';
import DeleteObject from '../../../common/poppers/DeleteObject';
import NewBankAccountNumber from '../../bankaccountnumber/NewBankAccountNumber';
import Address from './Address';
import CustomerRow from './CustomerRow';
import ModifyCustomer from './ModifyCustomer';
import Name from './Name';
import TaxNumber from './TaxNumber';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import DeleteIcon from '@material-ui/icons/Delete';

export const customerActionItems = [
    {
        dataDialog: "modify-dialog",
        title: "Módosít",
        dialogTitle: "Partner módosítása",
        icon: <EditIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <ModifyCustomer {...props} close={close} />
    },
    {
        mainMenu: "Hozzáadás",
        icon: <AddIcon fontSize="small" color="primary" />,
        subMenus: [
            {
                dataDialog: "new-bankaccount-dialog",
                title: "Bankszámlaszám",
                dialogTitle: "Bankszámlaszám hozzáadása",
                actionComponent: (props, close) => <NewBankAccountNumber {...props} close={close} />
            },
            {
                dataDialog: "taxnumber-dialog",
                title: "Adószám",
                dialogTitle: "Adószámok",
                actionComponent: (props, close) => <TaxNumber {...props} close={close} />
            },
            {
                dataDialog: "address-dialog",
                title: "Cím",
                dialogTitle: "Címek",
                actionComponent: (props, close) => <Address {...props} close={close} />
            },
            {
                dataDialog: "name-dialog",
                title: "Megnevezés",
                dialogTitle: "Megnevezés",
                actionComponent: (props, close) => <Name {...props} close={close} />
            },

        ]
    },
    {
        dataDialog: "active-dialog",
        title: "Aktiválás",
        dialogTitle: "Partner aktiválása",
        icon: <CheckCircleOutlineIcon fontSize="small" color="primary" />,
        canShow: (row) => !row.active,
        actionComponent: (props, close) => <ActivateObject {...props} close={close} path={'/api/activatecustomer'} comp={<CustomerRow {...props} />} />
    },
    {
        dataDialog: "active-dialog",
        title: "Inaktiválás",
        dialogTitle: "Partner inaktiválása",
        icon: <CancelOutlinedIcon fontSize="small" color="primary" />,
        canShow: (row) => row.active,
        actionComponent: (props, close) => <ActivateObject {...props} inactive={true} close={close} path={'/api/activatecustomer'} comp={<CustomerRow {...props} />} />
    },
    {
        divider: true,
    },
    {
        dataDialog: "delete-dialog",
        title: "Törlés",
        dialogTitle: "Partner törlése",
        icon: <DeleteIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <DeleteObject {...props} close={close} path={'/api/customer'} comp={<CustomerRow {...props} />} />
    }
];